var render = function render(){var _vm=this,_c=_vm._self._c;return _c('news-card',{attrs:{"item":_vm.item,"show-back-arrow":true,"limit-text":"1000000","image-height":_vm.imageHeight,"namespace":_vm.namespace}})
}
var staticRenderFns = []

export { render, staticRenderFns }